import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { filter, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ThaiComService {
    
    constructor(private http: HttpClient) {
    }

	getThaicomKey(){
		return this.http.get<any>(`${environment.API}${environment.URL_GET_THAICOM_KEY}`)
		.pipe(map(res => {
				return { ...res };
		})).toPromise();
	}

  	getArea(filter: string, auth_token: string, key: string): Promise<any> {
		var reqHeader = new HttpHeaders({ 
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${auth_token}`,
			'x-api-key': key
		});

		return this.http.get<any>(`${environment.THAICOM_IFARM_URL}ndvi-10m/area?` + filter, { headers: reqHeader })
		.pipe(map(res => {
				return { ...res };
		})).toPromise();
	}

	getPlantTypeById(planting_type_id: string): Promise<any> {
        return this.http.get<any>(`${environment.API}plantingtypes/${planting_type_id}`)
		.pipe(map(res => {
			return { ...res };
		})).toPromise();
  	}

	auth(key: string): Promise<any> {
		let body = new URLSearchParams();
		body.set('username', environment.THAICOM_USERNAME);
		body.set('password', environment.THAICOM_PASSWORD);
		
		var reqHeader = new HttpHeaders({ 
			'Content-Type': 'application/x-www-form-urlencoded',
			'x-api-key': key
		});
		
        return this.http.post<any>(`${environment.THAICOM_IFARM_AUTH_URL}auth/token`, body.toString(), { headers: reqHeader })
		.pipe(map(res => {
			return { ...res };
		})).toPromise();
  	}
}